import { useState, useEffect } from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { requirePropFactory } from "@mui/material";
import "./Catalogue.css";

function Catalogue() {
  const [outfit, setOutfit] = useState("");
  const [inputText, setInputText] = useState("");
  const [filtered, setFiltered] = useState([]);

  let data = [
    {
      id: 1,
      text: "Devpulse",
      image: "./pictures/IMG-20220824-WA0110.jpg",
      type: "casual",
    },
    {
      id: 2,
      text: "Linklinks",
      image: "./pictures/IMG-20220824-WA0111.jpg",
      type: "native",
    },
    {
      id: 3,
      text: "Centizu",
      image: "./pictures/IMG-20220824-WA0009.jpg",
      type: "native",
    },
    {
      id: 4,
      text: "Dynabox",
      image: "./pictures/IMG-20220824-WA0010.jpg",
      type: "casual",
    },
    {
      id: 5,
      text: "Corporate",
      image: "./pictures/IMG-20220824-WA0098.jpg",
      type: "casual",
    },
    {
      id: 6,
      text: "Male Model",
      image: "./pictures/IMG-20220824-WA0125.jpg",
      type: "casual",
    },
    {
      id: 7,
      text: "Rapapa",
      image: "./pictures/IMG-20220824-WA0119.jpg",
      type: "casual",
    },
    {
      id: 8,
      text: "Metico",
      image: "./pictures/IMG-20220824-WA0089.jpg",
      type: "casual",
    },
  ];

  const handleChange = (event) => {
    setOutfit(event.target.value);
  };

  let inputHandler = (e) => {
    //convert input text to lower case
    var lowerCase = e.target.value.toLowerCase();
    setInputText(lowerCase);
  };

  useEffect(() => {
    const filteredData = data.filter((el) => {
      //if no input the return the original
      if (inputText === "") {
        return el;
      }
      //return the item which contains the user input
      else {
        return el.text.toLowerCase().includes(inputText || outfit);
      }
    });
    setFiltered(filteredData);
  }, [inputText]);

  return (
    <div className="catalog-container">
      <div>
        <Navigation></Navigation>
      </div>
      <div className="catalog">
        <div className="catalog-search">
          <div className="catalogue-info">
            <p className="filter">{filtered.length} Apparel(s)</p>
            <div className="filter">
              <div>
                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Outfit
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={outfit}
                      label="Age"
                      onChange={handleChange}
                    >
                      <MenuItem value={"casual"}>Casual</MenuItem>
                      <MenuItem value={"native"}>Native</MenuItem>
                      <MenuItem value={"material"}>Material</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </div>
            </div>
          </div>
          <div className="filter-search">
            <TextField
              style={{ width: "67vw" }}
              id="outlined-basic"
              variant="outlined"
              label="Search for outfits"
              onChange={inputHandler}
            />
          </div>
        </div>

        {filtered.length > 0 ? (
          <div>
            <ul className="catalog-content">
              {filtered.map((item) => (
                <li key={item.id} className="catalog-item">
                  <div class="product-card">
                    <div class="badge">Hot</div>
                    <div class="product-tumb">
                      <img src={require(`${item.image}`)} alt="" />
                    </div>
                    <div class="product-details">
                      <span class="product-catagory">{item.type}</span>
                      <h4>
                        <a href="#">{item.text}</a>
                      </h4>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit. Vero, possimus nostrum!
                      </p>
                      <div class="product-bottom-details">
                        <div class="product-price">₦230.99</div>
                        <div class="product-links">
                          <a href="">
                            <i class="fa fa-heart"></i>
                          </a>
                          <a href="">
                            <i class="fa fa-shopping-cart"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div className="null-search">
            <h1>No Item Available</h1>
          </div>
        )}
      </div>
      <div className="catalog-footer">
        <Footer></Footer>
      </div>
      <style jsx>{``}</style>
    </div>
  );
}

export default Catalogue;
